export default {
 SET_TK_DATA (state, datain) {
    state.data = datain
  }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js